module.exports = __webpack_public_path__ + "img/th-list.51dca9cc.svg";